/**
 * Closed thematic interests on an attraction. Visit scenarios are not themes:
 * they are derived from scores and `routeMeta`.
 */
export enum AttractionThemeEnum {
    HISTORY = 'history',
    ARCHITECTURE = 'architecture',
    ART = 'art',
    RELIGION = 'religion',
    NATURE = 'nature',
    FOOD = 'food',
    SHOPPING = 'shopping',
    UNUSUAL = 'unusual',
    PANORAMA = 'panorama',
    CITY_LIFE = 'city_life',
    CULTURE = 'culture',
    ENTERTAINMENT = 'entertainment',
    TRADITIONS = 'traditions',
}
